import Cookies from 'js-cookie'

import Message from 'vue-m-message'

const state = {
  lang: localStorage.getItem('Language') || "cn",
  RouterAlive: true
}

const getters = {
}

const mutations = {
  TOGGLE_LANG: (state, type) => {
    state.lang = type;
    localStorage.setItem('Language',type);
  },
  RouterReload(state){
    state.RouterAlive = false;
    window.setTimeout(function(){
      state.RouterAlive = true;
    }, 0)
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js